import { useEffect } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import useCheckboxField from '../Checkbox/useCheckboxField';
import { ToggleProps } from './Toggle.types';

const usePresenter = (props: ToggleProps) => {
  const {
    checked,
    value,
    onValueChange,
    disabled = false,
    invalid = false,
    required,
    labelAlignment = 'Left',
    defaultChecked = false,
    children,
    ...otherInputProps
  } = props;

  const { isChecked, onCheckboxChanged } = useCheckboxField({ checked, defaultChecked, value, onValueChange });

  const variantProps = useBuildVariantProps(
    'toggle',
    {
      styles: isChecked ? 'selected' : 'unselected',
    },
    {
      disabled,
      invalid,
    },
  );

  return {
    variantProps,
    isChecked,
    onToggleChanged: onCheckboxChanged,
    otherInputProps,
    disabled,
    invalid,
    required,
    labelAlignment,
    defaultChecked,
  };
};

export default usePresenter;